<template>
  <div>
    <el-table
      v-loading="loading"
      :data="data"
      size="small"
    >
      <el-table-column
        label="STT"
        width="80"
        fixed="left"
        align="center"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.stt }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in fields"
        :key="field.key"
        :prop="field.key"
        :label="field.label"
        :width="field.width"
      >
        <template slot-scope="scope">
          <span v-if="field.key === 'created'">
            {{ scope.row[field.key] | convertDateTime("HH:mm DD/MM/YYYY") }}
          </span>
          <span v-else-if="field.key === 'name'">
            {{
              scope.row.translations.vi ? scope.row.translations.vi.name : ''
            }}
          </span>
          <span v-else-if="field.key === 'description'">
            {{
              scope.row.translations.vi ? scope.row.translations.vi.description : ''
            }}
          </span>
          <span v-else-if="field.key === 'status'">
            <el-tag
              v-if="scope.row[field.key] === 'enable'"
              type="success"
            >
              Enable
            </el-tag>
            <el-tag
              v-else
              type="danger"
            >
              Disabled
            </el-tag>
          </span>
          <span v-else>
            {{ scope.row[field.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Thao tác"
        width="100"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <Buttons
            :item="scope.row"
            :buttons="['detail']"
            @detail="(v) => $router.push({ name: 'ContractSteps', params: { id: v.id } })"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Buttons from "@/components/items/Buttons.vue";
import CONSTANTS from "@/config/constants";

export default {
  name: "CardList",
  components: {
    Buttons
  },
  props: {
    data: Array,
    loading: Boolean,
  },
  data() {
    return {
      fileType: CONSTANTS.FILE_TYPE,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "contract_type",
          label: "Loại",
        },
        {
          key: "name",
          label: "Tên",
        },
        {
          key: "description",
          label: "Mô tả",
        },
        {
          key: "created",
          label: "Ngày tạo",
        },
        {
          key: "status",
          label: "Trạng thái",
          align: "center",
          width: '100px'
        },
      ];
    },
  },
  methods: {
    //
  },
};
</script>

<style lang="scss"></style>
